import React from 'react';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

const MainInfoSkeleton = () => {
  return (
    <div className={style.mainInfoFields}>
      <div className={style.mainInfoPhoto}>
        <SkeletonBlock className={style.skeletonPhoto} />
      </div>
      <div className={style.skeletonTextWrapper}>
        <SkeletonBlock className={style.skeletonText} />
        <SkeletonBlock className={style.skeletonText} />
      </div>
    </div>
  );
};

export default MainInfoSkeleton;
